import React from 'react';

const IconCodeforces = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="code-forces"
    role="img"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-codeforces">
    <title>Codeforces</title>
    <path d="M22.062 21.125h-2.875a1.94 1.94 0 0 1-1.938-1.938V12a1.94 1.94 0 0 1 1.938-1.938h2.875A1.94 1.94 0 0 1 24 12v7.188a1.94 1.94 0 0 1-1.938 1.937zm-2.874-10.063a.939.939 0 0 0-.938.938v7.188c0 .517.42.938.938.938h2.875c.517 0 .938-.42.938-.938V12a.939.939 0 0 0-.938-.938h-2.875zm-5.75 10.063h-2.875a1.94 1.94 0 0 1-1.938-1.938V4.812a1.94 1.94 0 0 1 1.938-1.938h2.875a1.94 1.94 0 0 1 1.938 1.938v14.375a1.941 1.941 0 0 1-1.938 1.938zm-2.876-17.25a.939.939 0 0 0-.938.938v14.375c0 .517.42.938.938.938h2.875c.517 0 .938-.42.938-.938V4.812a.939.939 0 0 0-.938-.938h-2.875zm-5.75 17.25H1.938A1.94 1.94 0 0 1 0 19.188V9.125a1.94 1.94 0 0 1 1.938-1.938h2.875a1.94 1.94 0 0 1 1.938 1.938v10.062a1.941 1.941 0 0 1-1.939 1.938zM1.938 8.188A.938.938 0 0 0 1 9.125v10.062c0 .517.42.938.938.938h2.875c.517 0 .938-.42.938-.938V9.125a.939.939 0 0 0-.938-.938H1.938z"></path>
  </svg>
);

export default IconCodeforces;